import styled from 'styled-components'
import { Form as ReduxForm, Field as ReduxField } from 'redux-form'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { H1 } from 'components/common/Text/Text'

export const Instructions = styled.p`
  margin: 15px 0 25px;
  line-height: 22px;
`

export const Form = styled(ReduxForm)`
  position: relative;
  text-align: left;
  background: ${Theme.colors.white};
  ${Mixin.responsive('padding', '11px 18px 67px 24px', '12px 16px 0')}
  ${Mixin.responsive('width', '528px', '100%')}
  ${Media.mobile`
    height: 100%;
  `}
`

export const Title = styled(H1)`
  text-transform: uppercase;
  ${Mixin.responsive('margin-top', '14px', '48px')}
  ${props => Mixin.font.GothamBold(props.size || 26, 600)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(20, 600)}
  `}
`

export const Field = styled(ReduxField)`
  margin-bottom: 25px;
  ${Media.desktop`
    max-width: 100%;
    width: 312px;
  `}
`
